export default __webpack_public_path__ + "static/media/s70-outside.a480f1ff.jpg";